import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  Title,
  Datagrid,
  TextField,
} from 'react-admin';

import { Card } from '@material-ui/core';

import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { PERMISSAO_TELA_NCMS_LISTAR } from '../../utils/dadosTelas';
import ActionsList from './ActionsList';
import DialogoImportarJSONNcm from './DialogoImportarJSONNcm';
import Filter from './Filter';

const MyList = ({ ...props }) => {
  const refDialogoImportarJSONNcm = useRef(null);

  function handleTabelaNcm() {
    if (refDialogoImportarJSONNcm.current) {
      refDialogoImportarJSONNcm.current.handleOpen();
    }
  }

  return (
    <>
      <Title title="Tabela Ncm" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleTabelaNcm={handleTabelaNcm} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="codigo" label="Código" />
          <TextField source="descricao" label="Descrição" />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoImportarJSONNcm
        ref={refDialogoImportarJSONNcm}
        handleClose={() => {}}
      />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_NCMS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Tabela Ncm"
      component="div"
    />
  </ProtegerPagina>
);

export default List2;
